<template>
	<div class="goods-form-wrapper">
		<div class="header-sidebar mb-4" slot="header">
			<h4 class="pull-left" v-if="mode === 'create'">
				{{ $t('promo-to-product.new-promo') }}
			</h4>
			<h4 class="pull-left" v-else>
				{{ $t('promo-to-product.promo') }} - {{ newPromo.name }}
			</h4>
			<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i
					class="fa fa-close"></i></b-button>
			<div class="clearfix"></div>
			<hr>
		</div>
		<form>
			<b-container fluid id="newPromoId" class="promotion">
				<b-form-group>
					<b-row>
						<b-col cols="3">
							<label :for="department">{{ $t('promo-to-product.department') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col cols="9">
							<b-form-group class="required">
								<multiselect :disabled="mode === 'view'" v-model="department" :options="listWarehouse"
									id="department" name="deps" class="is-invalid required" track-by="id" label="name"
									:placeholder="$t('promo-to-product.department')">
								</multiselect>
							</b-form-group>
						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.comment">{{ $t('promo-to-product.comment') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-input :disabled="mode === 'view'" size="sm" id="comment"
								v-model="newPromo.comment" name="comment" autocomplete="off"
								v-validate="validators.comment" :placeholder="$t('promo-to-product.comment')" />
						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.start">{{ $t('promo-to-product.start-date') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<masked-input :disabled="mode === 'view'" v-model="newPromo.start" mask="11-11-1111"
								name="start" class="form-control form-control-sm" v-validate="validators.start" />
						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.finish">{{ $t('promo-to-product.finish-date') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<masked-input :disabled="mode === 'view'" v-model="newPromo.finish" mask="11-11-1111"
								name="finish" class="form-control form-control-sm" v-validate="validators.finish" />
						</b-col>
					</b-row>
				</b-form-group>
				<!-- <b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.status">{{ $t('promo-to-product.status') }} <span class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-select v-model="newPromo.status" v-validate="validators.status" :plain="false" name="status" size="sm" :required="true" :text-field="'name'" :value-field="'id'">
								<template slot="first">
									<option :value="null" disabled>
										--{{ $t('promo-to-product.select-status') }}--
									</option>
									<option value="ACTIVE">{{ $t('promotionForm.active') }}</option>
									<option value="PENDING">{{ $t('promotionForm.pending') }}</option>
									<option value="INACTIVE">{{ $t('promotionForm.inactive') }}</option>
									<option value="REJECTED">{{ $t('promotionForm.rejected') }}</option>
								</template>
</b-form-select>
</b-col>
</b-row>
</b-form-group> -->
				<b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.name">{{ $t('promo-to-product.name') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-input :disabled="mode === 'view'" size="sm" id="name" v-model="newPromo.name"
								name="name" autocomplete="off" v-validate="validators.name"
								:placeholder="$t('promo-to-product.name')" />
						</b-col>
					</b-row>
				</b-form-group>
				<!-- <b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.promotionType">{{ $t('promo-to-product.type') }} <span class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<b-form-select v-model="newPromo.promotionType" size="sm" name="type" v-validate="validators.type">
								<option v-for="(selectOption, indexOpt) in promoType" :key="indexOpt" :value="selectOption.code">
									{{ selectOption.name }}
								</option>
								<template slot="first">
									<option :value="null" disabled>-- {{ $t('promo-to-product.type') }} --</option>
								</template>
							</b-form-select>
						</b-col>
					</b-row>
				</b-form-group> -->
				<!-- <b-form-group v-if="newPromo.promotionType ==='X+N' ">
					<b-row class="my-1">
						<b-col sm="3"></b-col>
						<b-col sm="4">
							<label>Размер скидки</label>
							<b-input-group append="%" size="sm">
								<b-form-input v-model="newPromo.promoX" autocomplete="off" type="number"></b-form-input>
							</b-input-group>
						</b-col>
						<b-col sm="4">
							<label>Единиц товара</label>
							<b-input-group append="ед / товар" size="sm">
								<b-form-input v-model="newPromo.promoN" autocomplete="off" type="number"></b-form-input>
							</b-input-group>
						</b-col>
					</b-row>
				</b-form-group> -->
				<!-- <b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.discount">{{ $t('promo-to-product.discount') }} <span class="text-danger">*</span> </label>
						</b-col>
						<b-col sm="9">
							<b-form-input size="sm" id="discount" v-model="newPromo.discount" name="discount" autocomplete="off" v-validate="validators.discount" :placeholder="$t('promo-to-product.discount')" type="number"/>
						</b-col>
					</b-row>
				</b-form-group> -->
				<!-- <b-form-group>
					<b-row class="my-1">
						<b-col sm="3">
							<label :for="newPromo.deps">{{ $t('promo-to-product.department') }} <span
									class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<multiselect v-model="newPromo.deps" v-validate="validators.deps" :options="listWarehouse"
								:multiple="true" name="deps" class="is-invalid" track-by="id" label="name"
								:placeholder="$t('promo-to-product.department')" />
						</b-col>
					</b-row>
				</b-form-group> -->
				<b-form-group v-if="mode === 'create'">
					<b-row class="my-1">
						<b-col sm="3">
							<label>{{ $t('promo-to-product.search') }} <span class="text-danger">*</span></label>
						</b-col>
						<b-col sm="9">
							<!--							<multiselect v-model="dropDowns.product.value"-->
							<multiselect v-model="createPromo.whItems.itemId" :options="searchItems" :searchable="true"
								:show-labels="false" :internal-search="false" :close-on-select="true" label="name"
								track-by="id" @search-change="loadItems($event)"
								:placeholder="$t('incomes.create.product')">

								<template slot="singleLabel" slot-scope="props">
									<span v-if="props.option.wrapped" style="color: blue;">
										<strong><b>Уп.</b> - </strong>{{ props.option.barcode }} / {{
											props.option.artikul }} / {{
											props.option.colorName
										}} / {{
											props.option.size
										}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
									</span>
									<span v-else>
										{{ props.option.artikul }} / {{
											props.option.barcode
										}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
									</span>
								</template>

								<template slot="option" slot-scope="option">
									<span v-if="option.option.wrapped" style="color: blue;">
										<strong><b>Уп.</b> - </strong>{{ option.option.barcode }} / {{
											option.option.artikul
										}} / {{ option.option.colorName }} / {{
											option.option.size
										}} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }}
										<span> /<strong>{{ $t('sale.kol-vo') }}:</strong> {{
											option.option.count1
										}} / <strong>Цена:</strong> </span>
									</span>
									<span v-else>
										{{ option.option.artikul }} / {{
											option.option.barcode
										}} / {{
											option.option.name ? option.option.name.substring(0, 30) : ''
										}} <span> / <strong>{{ $t('sale.kol-vo') }}:</strong> {{
											option.option.count1
										}} / <strong>Цена:</strong> {{ option.option.price }} </span>
									</span>
								</template>
							</multiselect>
						</b-col>
					</b-row>
				</b-form-group>
				<b-form-group>
					<hr>
					<b-row class="generalTableClass">
						<b-table show-empty striped hover :items="addItems" :fields="computedFields">
							<template slot="id" slot-scope="data">
								<!--								{{ data.index + 1 }}-->
								{{ paginate(data.index, searchForm.page, searchForm.limit) }}
							</template>
							<template slot="multiBarcode" slot-scope="data">
								<div v-for="tmp in data.item.multiBarcodes">
									{{ tmp.barcode }}
								</div>
							</template>
							<template slot="artikul" slot-scope="data">
								<div v-for="(tmp, index) in data.item.vendorCodes" :key="`qwe-${index}`">
									{{ tmp.vendor }}
								</div>
							</template>
							<template slot="buyQuantity" slot-scope="data">
								<b-input v-if="mode === 'create'" size="md" id="buyQuantity"
									v-model="data.item.buyQuantity" name="buyQuantity" autocomplete="off"
									:placeholder="$t('Купи Х')" :min="1" type="number" />
								<span v-else>{{ data.item.buyQuantity }}</span>
							</template>
							<template slot="freeQuantity" slot-scope="data">
								<b-input v-if="mode === 'create'" size="md" id="freeQuantity"
									v-model="data.item.freeQuantity" name="freeQuantity" autocomplete="off"
									:placeholder="$t('Получи Y')" :min="1" type="number" />
								<span v-else>{{ data.item.freeQuantity }}</span>
							</template>
							<template slot="empty" slot-scope="scope">
								<span v-if="!selectAll">{{ $t('empty') }}</span>
								<div v-else class="bg-success p-2" style="width:100%;margin:0">
									<span style="font-size:18px">{{
										$t('promo-to-product.selected-all-items')
									}}</span>
								</div>
							</template>
							<template slot="actions" slot-scope="data">
								<div v-if="mode === 'create'">
									<b-link @click="deleteSelectItem(data.index)">
										<i class="fa fa-trash"></i>
									</b-link>
								</div>
							</template>
						</b-table>
					</b-row>
				</b-form-group>
			</b-container>
			<div class="modal-actions">
				<b-row class="align-items-center" style="padding-bottom: 10px">
					<b-col cols="6" class="mb-3 mb-xl-0" style="padding-top: 45px;">
						<b-row>
							<b-col cols="5">
								<b-button block size="sm" type="button" @click="cancel" :disabled="loadingForNewPromo"
									variant="outline-danger">{{ $t('cancel') }}</b-button>
							</b-col>
							<b-col cols="5" v-if="mode === 'create'">
								<b-button block type="button" size="sm" @click="create" :disabled="loadingForNewPromo"
									variant="primary">{{ $t('save') }}</b-button>
							</b-col>
							<b-col cols="2">
								<!-- SMALL LOADER -->
								<b-spinner v-if="loadingForNewPromo" small class="ml-2" variant="primary"
									label="Small Spinner"></b-spinner>
								<!-- SMALL LOADER -->
							</b-col>
						</b-row>
					</b-col>
				</b-row>
			</div>
		</form>
	</div>
</template>

<script>
import AddChildren from "./AddChildren";
import { validators } from "../mixins/validators";
import PromoService from "../../../../services/promo.service";
import MaskedInput from 'vue-masked-input'
import WhDocument from '../../../../services/wh-document.service'
import { mapGetters, mapActions, mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
	name: 'NewPromo',
	props: {
		mode: {
			type: String,
			default: 'create'
		},
		edit: {
			type: Object,
			default: null
		},
		totalForEdit: {
			type: Number,
			default: 0
		}
	},
	mixins: [validators],
	data() {
		return {
			selectAll: false,
			computedFields: [
				{
					key: 'id',
					label: '№',
					'class': 'width8_wordBreak',
					sortable: true
				},
				{
					key: 'barcode',
					label: this.$t('goods.special-barcode'),
					'class': 'incomeItemArtikul',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'name',
					label: this.$t('goods.name'),
					'class': 'incomeItemArtikul',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'multiBarcode',
					label: this.$t('goods.barcode'),
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'artikul',
					label: this.$t('goods.artikul'),
					visible: true,
					changebale: true
				},
				// {
				// 	key: 'termOfItem',
				// 	label: this.$t('kirim.expirationDate'),
				// 	visible: false,
				// 	changebale: true
				// },
				// {
				// 	key: 'oldPriceUzs',
				// 	label: this.$t('promo-to-product.oldPrice'),
				// 	'class': 'not-first',
				// 	sortable: true,
				// 	visible: true,
				// 	changebale: true
				// },
				// {
				// 	key: 'count1Old',
				// 	label: this.$t('incomes.balance'),
				// 	'class': 'incomeItemSize',
				// 	sortable: true,
				// 	visible: true,
				// 	changebale: true
				// },
				{
					key: 'buyQuantity',
					label: this.$t('Купи Х'),
					'class': 'td-20',
					sortable: true,
					visible: true,
					changebale: true
				},
				{
					key: 'freeQuantity',
					label: this.$t('Получи Y'),
					'class': 'td-20',
					sortable: true,
					visible: true,
					changebale: true
				},
				// {
				// 	key: 'actions',
				// 	label: this.$t('actions.title'),
				// 	'class': 'td-20',
				// 	sortable: true,
				// 	visible: true,
				// 	changebale: true
				// }
			],
			searchCollect: {
				plus: [],
				minus: []
			},
			mapIds: {
				plusIds: [],
				minusIds: []
			},
			totalPlus: 0,
			totalMinus: 0,
			searchItems: [],
			addItems: [],
			selectedDepId: null,
			nvSpiskaDisabledButton: true,
			dobavitDisabledButton: false,
			refreshDisabledButton: true,
			check: false,
			total: 0,
			newMessForSpisok: '',
			whDocument: {},
			responseArray: [],
			department: null,
			createPromo: {
				comment: '',
				start: '',
				finish: '',
				status: null,
				itemsList: [],
				selectedIds: [],
				itemsUnnecessary: [],
				name: '',
				// promotionType: null,
				discount: '',
				deps: [],
				depsArray: [],
				promoX: 0,
				promoN: 0,
				whItems: {
					itemId: null,
					priceUzs: '',
					oldPriceUzs: '',
					count: null,
					documentId: null,
				}
			},
			searchForm: {
				page: 1,
				limit: 20,
			},
			depsArray: [],
			newPromo: null,
			promotionPlusForUpdate: [],
			promotionMinusForUpdate: [],
			childModal: false,
			loadingForNewPromo: false
		}
	},
	methods: {
		...mapActions('promo', ['fetchDepartment', 'searchDoubleDiscountStore']),
		...mapActions('references', ['getReferenceChildren']),
		...mapActions('departments', ['fetchMyDepartments']),

		deleteSelectItem(id) {
			this.addItems.forEach((item, index) => {
				if (index === id) {
					this.addItems.splice(id, 1);
				}
			});
		},
		cancel() {
			this.$emit('close', true);
		},
		dobavitSpisok(newMessSpisok) {
			this.childModal = true;
			this.newMessForSpisok = newMessSpisok;
		},
		newSpisok(newMessSpisok) {
			this.childModal = true;
			this.newMessForSpisok = newMessSpisok;
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		async create() {
			this.$validator.validate().then(valid => {
				if (valid) {
					let formInput = {
						comment: this.newPromo.comment,
						start: this.newPromo.start,
						finish: this.newPromo.finish,
						// status: this.newPromo.status,
						// itemIds: this.newPromo.selectedIds,
						// itemsUnnecessary: this.newPromo.itemsUnnecessary,
						name: this.newPromo.name,
						// promotionType: this.newPromo.promotionType === "PERCENTAGE" ? "%" : this.newPromo.promotionType,
						// discount: this.newPromo.discount,
						departmentIds: [this.selectedDepId],
						promotionSimpleItems: this.addItems.map(item => ({ itemId: item.id, buyQuantity: +item.buyQuantity, freeQuantity: +item.freeQuantity }))
					}
					this.newPromo.deps.forEach(deps => {
						formInput.departmentIds.push(deps.id)

					})
					let map = {
						plus: this.searchCollect.plus,
						minus: this.searchCollect.minus,
					}
					formInput.map = map;

					if (this.newPromo.id)
						formInput.id = this.newPromo.id
					this.loadingForNewPromo = true;
					if (this.mode == 'create') {
						PromoService.promotionSimpleAdd(formInput).then(res => {
							this.loadingForNewPromo = false;

							this.$emit('success', true);
						}).catch(error => {
							console.log(error);
							this.loadingForNewPromo = false;

							this.$vs.notify({
								text: 'Хатолик йуз берди, яна уриниб коринг',
								color: 'warning',
								icon: 'close',
								position: 'top-right'
							});
						});
					}
					if (this.mode == 'edit') {
						formInput.mapIds = this.mapIds;
						PromoService.updateFinished(formInput).then(response => {
							if (response.data == 'success') {
								this.$emit('success', true);
							}
							this.childModal = false;
						})
					}
				} else {
					this.$vs.notify({
						title: this.$t('words.error'),
						text: 'Заполните все обязательное поле',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}
			});
			return false;
		},
		async getItem(id) {
			await PromoService.promotionSimpleGet(id).then(response => {
				let data = response.data
				console.log(data)

				this.department = data.departmentsList[0]
				this.newPromo.comment = data.comment
				this.newPromo.start = data.start
				this.newPromo.finish = data.finish
				this.newPromo.name = data.name
				this.addItems = data.promotionSimpleItemDtoList.map(value => ({ ...value, ...value.item }))
			}).catch(error => {
				console.log(error);

				this.loadingForNewPromo = false;

				this.$vs.notify({
					text: 'Хатолик йуз берди, бир оздан сонг яна уриниб коринг',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});

				this.cancel()
			});
		},
		async loadItems($event) {
			await this.getListByProductsNotKirimFunction(this.selectedDepId, $event)
		},
		async getListByProductsNotKirimFunction(id, keyword) {
			await WhDocument.getListByProductsNotKirimServiceFunctionNew(id, keyword).then(response => {
				this.searchItems = response.data;
			})
		},
	},
	created() {
		this.fetchMyDepartments();
		this.getReferenceChildren("Promotion_type")
		if (this.mode === 'create') {
			this.nvSpiskaDisabledButton = true;
			this.dobavitDisabledButton = false;
			this.newPromo = this.createPromo
		} else {
			this.newPromo = this.createPromo
			this.getItem(this.edit.id)
			// let obj = Object.assign({}, this.edit)
			// obj.selected = []
			// obj.selectedIds = []
			// this.edit.itemsList.forEach(item => {
			// 	obj.selected.push({
			// 		wrappedId: item.id,
			// 		subCategoryName: item.subCategoryName,
			// 		sub2CategoryName: item.sub2CategoryName,
			// 		sub3CategoryName: item.sub3CategoryName ? item.sub3CategoryName : '',
			// 		multiBarcodes: item.multiBarcodes,
			// 		artikul: item.artikul,
			// 		vendorCodes: item.vendorCodes,
			// 		model: item.model,
			// 		sku: item.sku,
			// 		barcode: item.barcode,
			// 		size: item.size,
			// 		name: item.name,
			// 	});
			// 	obj.selectedIds.push(item.id)
			// })
			// obj.itemsList = obj.selected
			// obj.deps = obj.departmentsList
			// // obj.promotionType = obj.promotionType === "%" ? "PERCENTAGE" : obj.promotionType,
			// // 	this.newPromo = obj;
			// this.nvSpiskaDisabledButton = false;
			// this.dobavitDisabledButton = false;
		}
	},
	computed: {
		listWarehouse() {
			return this.myDepartments.filter(item => {
				return item;
			})
		},
		...mapGetters('promo', {
			'allDeps': 'getDeps'
		}),
		...mapGetters('departments', [
			'myDepartments'
		]),
		...mapState('references', {
			'promoType': 'refPaymentType'
		}),
		...mapState('promo', [
			'searchDoubleDiscount', 'promotionId'
		]),
	},
	watch: {
		'searchForm.page': {
			async handler() {
				let data = {
					plus: this.searchCollect.plus,
					minus: this.searchCollect.minus,
				}
				if (this.mode == 'create') {
					PromoService.savePromotionDoubleArray(data, this.searchForm).then(response => {
						this.newPromo.itemsList = response.data.items
						this.total = response.data.total;
						this.responseArray = response.data;
					});
				}
				if (this.mode == 'edit') {
					if (this.newMessForSpisok !== 'minus' && this.newMessForSpisok !== 'plus') {
						PromoService.simplePromotion(this.promotionId, this.searchForm).then(response => {
							this.newPromo.itemsList = response.data.itemList
							this.totalForEdit = response.data.total;
							this.responseArray = response.data;
						}
						);
					}
					if (this.newMessForSpisok == 'minus') {
						PromoService.updateCollectMinusArray(data, this.searchForm).then(response => {
							this.promotionMinusForUpdate = response.data.items;
							this.mapIds.minusIds = response.data.items[0].itemIds
							this.totalMinus = response.data.total;
							this.childModal = false
						})
					}
				}
			}
		},
		'department': {
			deep: true,
			async handler(value) {
				if (value) {
					this.selectedDepId = value.id
					await this.getListByProductsNotKirimFunction(this.selectedDepId, null);
				} else {
					this.searchItems = []
				}
			}
		},
		'createPromo.whItems.itemId': {
			deep: true,
			handler(value) {
				if (value) {
					let hasSelected = this.addItems.find(item => item.id === this.createPromo.whItems.itemId.id && item.incomeDocId == this.createPromo.whItems.itemId.incomeDocId)

					if (!hasSelected) {
						let currentObj = {
							...this.createPromo.whItems.itemId,
							buyQuantity: this.createPromo.whItems.itemId.buyQuantity,
							freeQuantity: this.createPromo.whItems.itemId.freeQuantity,
						}
						this.addItems.push(currentObj)
						// this.createPromo.whItems.itemId = null
						// this.createPromo.whItems.itemId.price = 0
						// this.createPromo.whItems.itemId.count1 = 0
					}
					this.createPromo.whItems.itemId = null
				}
			}
		}
	},
	components: {
		AddChildren,
		MaskedInput,
		Multiselect
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
#newPromoId {
	.form-group {
		margin-bottom: .5rem;
	}
}

.invalid .multiselect__tags {
	border-color: red;
}

.addItemsModalHeader {
	display: flex;
	width: 100%;
	justify-content: space-between;

	.close {
		font-size: 18px;
	}
}
</style>
